import React from 'react';
import Button from '@/components/Buttons/Button';
import { scrollToBottomStyle } from './scrollToBottomStyle';

// Shared by the desktop chat surfaces; keep the arrow, circle and hit target
// identical when the transcript itself has a platform-specific renderer.
export default function ScrollToBottomButton({ style, ...props }) {
  return <Button variant="secondary" size="small" isRound prependIcon="arrow-down"
    tooltip="Scroll to bottom" accessibilityLabel="Scroll to bottom"
    {...props} style={[scrollToBottomStyle, style]} />;
}
